import {
  OrganizationService,
  TransactionFlowTypesEnum,
  EntityType,
} from "@propertelligent/client-api";
import { useEffect, useState, useRef } from "react"; // <-- 1. Import useRef
import useInfiniteScroll from "react-infinite-scroll-hook";
import SimpleSpinner from "../../components/loader";
import SeparaterLine from "../../components/common/SeparaterLine";
import apiHelper from "../../utils/apiHelper";
import AddTraspButton from "../../components/firstTimeUserExperience/commonCom/AddTraspButton";
import { GetImages } from "../../utils/GetImages";
import CustomInputs from "../../components/common/Inputs";
import { FORM_CONTROLFIELD_TYPES } from "../../constants/constants";
import GenericSearchAbleDropdown from "../../components/common/GenericSearchAbleDropdown";
import { convertENUMtoJSONArray } from "../../utils/helper";
import DateHelper from "../../utils/DateHelper";
import { NotificationType, PubSub, TopicsEnum } from "../../utils/pubsub";
import CustomTooltip from "../../components/common/CustomTooltip";
import CurrencyTooltip from "../../components/currencytooltip/CurrencyTooltip";
import EmptyState from "../emptystate";
import { usePermissions } from "../../hooks/usePermissions";

const FlatViewTable = ({
  payeeAccountData,
  setIsEdit,
  paymentMethodsArr,
  rows,
  loading,
  hasMore,
  fetchData,
  currentPage,
  calculateValue,
  aggregateValues,
  formattedAggregateValues,
  loading1,
  entityTypeId,
}) => {
  const [currentItem, setCurrentItem] = useState(null);
  const [editRowIndex, setEditRowIndex] = useState(null);
  const [data, setData] = useState([]);
  const { canWrite } = usePermissions();
  const hasWritePermission = canWrite("Transaction");

  // Create a ref for the scrollable container
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  // CustomTooltipWrapper removed in favor of imported CustomTooltip

  useEffect(() => {
    setData(rows);
  }, [rows]);

  const loadMoreRecords = () => {
    if (!loading && hasMore) {
      fetchData(currentPage + 1);
    }
  };

  const handleEditRow = (txIndex) => {
    setEditRowIndex(txIndex);
  };

  // <-- 3. Tell the hook to use the tbody as its 'root'
  const [sentryRef] = useInfiniteScroll({
    loading: loading,
    hasNextPage: hasMore,
    onLoadMore: loadMoreRecords,
    rootMargin: "0px 0px 100px 0px",

    // @ts-ignore
    root: scrollContainerRef.current,
  });

  const handleEdit = () => {
    if (data.length && currentItem) {
      let updatedValues = data.find((row) => row?.id === currentItem?.id);
      updatedValues = {
        ...updatedValues,
        transactionId: updatedValues?.transactionId,
      };
      if (!updatedValues) return;
      const { amount, transactionId } = updatedValues;
      if (!amount || !transactionId) {
        PubSub.publish(TopicsEnum.Notification.toString(), {
          type: NotificationType.Failure,
          message: "Please fill all the fields",
        });
        setIsEdit(true);
        return;
      }
      apiHelper(
        OrganizationService.putApiOrganizationTransaction,
        {
          successMessage: "Successfully Updated Transaction",
          showNotification: true,
        },
        currentItem?.id,
        updatedValues,
      )
        .then((response) => {
          if (response) {
            setIsEdit(false);
            fetchData(1);
          }
        })
        .catch((Err) => {
          console.error({ Err });
          PubSub.publish(TopicsEnum.Notification.toString(), {
            type: NotificationType.Failure,
            message: "Failed to update transaction. Try again.",
          });
          setIsEdit(true);
        });
    }
  };

  const handleSaveRow = (txIndex) => {
    setEditRowIndex(null);
  };

  const handleChange = (item, field, value, index) => {
    setCurrentItem(item);
    setData((prevData) => {
      const updatedData = [...prevData];
      updatedData[index] = { ...updatedData[index], [field]: value };
      return updatedData;
    });
  };

  return (
    <div className="flat-view-border-container d-flex flex-column flex-grow-1 h-100">
      {(loading || loading1) && rows.length === 0 ? (
        <div className="d-flex justify-content-center align-items-center flex-grow-1 w-100" style={{ minHeight: "60vh" }}>
          <SimpleSpinner myClassName="Icon50" />
        </div>
      ) : (
        <>
          <div className="table-responsive" ref={scrollContainerRef}>
            <table className="collapsible-table">
              <thead className="transaction-table-header">
            {/* ... (Your thead content remains unchanged) ... */}
            <tr>
              <th>
                <span>Description</span>
              </th>
              <th>
                <span>From</span>
              </th>
              <th>
                <span>To</span>
              </th>
              <th>
                <span>Method</span>
              </th>
              <th>
                <span>Reference</span>
              </th>
              <th>
                <span>Category</span>
              </th>
              <th>
                <span>Amount</span>
              </th>
              <th>
                <span>Date</span>
              </th>
              <th>
                <span>Transaction ID</span>
              </th>
              {entityTypeId !== EntityType.Tenant && hasWritePermission && (
                <th>
                  <span>
                    <p>0</p>
                  </span>
                </th>
              )}
            </tr>
          </thead>

          {/* <-- 4. Attach the ref to the tbody element --> */}
          <tbody className="">
            {!loading1 && rows.length === 0 ? (
              /* 2. NO DATA FOUND / ERROR STATE */
              <tr>
                <td
                  colSpan={entityTypeId !== EntityType.Tenant && hasWritePermission ? 10 : 9}
                  style={{ textAlign: "center", padding: "40px" }}
                >
                  <EmptyState
                    icon={GetImages.emptyStatePayment}
                    className="bg-transparent"
                    isBorder={false}
                    heading="No transaction found"
                    isButton={false}
                  />
                </td>
              </tr>
            ) : (
              rows.map((item, txIndex) => (
                <tr
                  key={txIndex}
                  className="tooltip-main-row"
                  style={{ height: "unset" }}
                >
                  {/* ... (All your <td> cells remain unchanged) ... */}
                  <td>
                    <div className="normal_text ">
                      <span className="d-flex gap-1 align-items-center ">
                        {editRowIndex === txIndex ? (
                          <CustomInputs
                            value={data[txIndex]?.description}
                            onChange={(e) =>
                              handleChange(
                                item,
                                "description",
                                e.target.value,
                                txIndex,
                              )
                            }
                            myClassName="border-0"
                            name="description"
                            type={FORM_CONTROLFIELD_TYPES.TEXT}
                            isFormControl={true}
                            placeholder="Enter Description"
                          />
                        ) : (
                          <CustomTooltip content={item?.description} />
                        )}
                      </span>
                    </div>
                  </td>
                  <td className="normal_text">
                    {editRowIndex === txIndex ? (
                      <GenericSearchAbleDropdown
                        key={txIndex}
                        fieldName="accountName"
                        initialOptions={paymentMethodsArr}
                        name="accountName"
                        isFormControl={true}
                        value={Number(data[txIndex]?.paymentMethodId)}
                        onChange={(e) =>
                          handleChange(
                            item,
                            "paymentMethodId",
                            Number(e.target.value),
                            txIndex,
                          )
                        }
                        placeholder="Select Payment Method"
                        myClassName="normal_text border-0"
                        style={{ height: "46px" }}
                      />
                    ) : (
                      <CustomTooltip content={item?.paymentMethodAccountName} />
                    )}
                  </td>
                  <td className="normal_text">
                    {editRowIndex === txIndex ? (
                      <GenericSearchAbleDropdown
                        fieldName="accountName"
                        initialOptions={payeeAccountData}
                        name="accountName"
                        isFormControl={true}
                        value={Number(data[txIndex]?.payeeAccountId)}
                        onChange={(e) =>
                          handleChange(
                            item,
                            "payeeAccountId",
                            Number(e.target.value),
                            txIndex,
                          )
                        }
                        placeholder="Select Payee Account"
                        myClassName="normal_text border-0"
                        style={{ height: "46px" }}
                      />
                    ) : (
                      <CustomTooltip content={item?.payeeAccountName} />
                    )}
                  </td>
                  <td className="normal_text">
                    {editRowIndex === txIndex ? (
                      <GenericSearchAbleDropdown
                        fieldName="accountName"
                        initialOptions={paymentMethodsArr}
                        name="accountName"
                        isFormControl={true}
                        value={Number(data[txIndex]?.paymentMethodId)}
                        onChange={(e) =>
                          handleChange(
                            item,
                            "paymentMethodId",
                            Number(e.target.value),
                            txIndex,
                          )
                        }
                        placeholder="Select Payment Method"
                        myClassName="normal_text border-0"
                        style={{ height: "46px" }}
                      />
                    ) : (
                      <CustomTooltip
                        content={item?.formatted?.PaymentMethodTypeId}
                      />
                    )}
                  </td>
                  <td className="normal_text">
                    {editRowIndex === txIndex ? (
                      <CustomInputs
                        value={data[txIndex]?.reference}
                        onChange={(e) =>
                          handleChange(
                            item,
                            "reference",
                            e.target.value,
                            txIndex,
                          )
                        }
                        myClassName="border-0 compact-input"
                        name="reference"
                        type={FORM_CONTROLFIELD_TYPES.TEXT}
                        isFormControl={true}
                        placeholder="Enter Reference No."
                      />
                    ) : (
                      <div className="compact-cell">
                        <CustomTooltip content={item?.reference}>
                          <span
                            className="d-inline-block text-truncate"
                            style={{ maxWidth: "100%" }}
                          >
                            {item?.reference}
                          </span>
                        </CustomTooltip>
                      </div>
                    )}
                  </td>
                  <td className="normal_text">
                    {editRowIndex === txIndex ? (
                      <GenericSearchAbleDropdown
                        fieldName="name"
                        initialOptions={convertENUMtoJSONArray(
                          TransactionFlowTypesEnum,
                        )}
                        name="name"
                        isFormControl={true}
                        value={Number(
                          data[txIndex]?.tranactionCreditDebitTypeId,
                        )}
                        onChange={(e) =>
                          handleChange(
                            item,
                            "tranactionCreditDebitTypeId",
                            Number(e.target.value),
                            txIndex,
                          )
                        }
                        placeholder="Select Payment Method"
                        myClassName="normal_text border-0"
                        style={{ height: "46px" }}
                      />
                    ) : (
                      <CustomTooltip
                        content={item?.formatted?.TranactionCreditDebitTypeId}
                      />
                    )}
                  </td>
                  <td className="normal_text">
                    {editRowIndex === txIndex ? (
                      <CustomInputs
                        value={data[txIndex]?.amount}
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          if (
                            /^[0-9]*\.?[0-9]*$/.test(inputValue) ||
                            inputValue === ""
                          ) {
                            handleChange(item, "amount", inputValue, txIndex);
                          }
                        }}
                        myClassName="border-0"
                        name="amount"
                        type={FORM_CONTROLFIELD_TYPES.TEXT}
                        isFormControl={true}
                        placeholder="Enter Amount"
                      />
                    ) : (
                      <CurrencyTooltip
                        content={item?.formatted?.AmountRaw}
                        formatted={item?.formatted?.Amount}
                      >
                        <span>{item?.formatted?.Amount}</span>
                      </CurrencyTooltip>
                    )}
                  </td>
                  <td className="normal_text">
                    {editRowIndex === txIndex ? (
                      <CustomInputs
                        value={DateHelper.convertUTCtoDateTime2(
                          data[txIndex]?.paymentDate,
                        )}
                        onChange={(e) =>
                          handleChange(
                            item,
                            "paymentDate",
                            new Date(e.target.value),
                            txIndex,
                          )
                        }
                        myClassName="border-0"
                        name="paymentDate"
                        type={FORM_CONTROLFIELD_TYPES.DATE}
                        isFormControl={true}
                        placeholder="Enter Date"
                      />
                    ) : (
                      <CustomTooltip
                        content={item?.formatted?.PaymentDateDateOnly}
                      />
                    )}
                  </td>
                  <td className="normal_text">
                    {editRowIndex === txIndex ? (
                      <CustomInputs
                        value={data[txIndex]?.transactionId}
                        onChange={(e) =>
                          handleChange(
                            item,
                            "transactionId",
                            e.target.value,
                            txIndex,
                          )
                        }
                        myClassName="border-0 compact-input"
                        name="transactionId"
                        type={FORM_CONTROLFIELD_TYPES.TEXT}
                        isFormControl={true}
                        placeholder="Enter Transaction Id"
                      />
                    ) : (
                      <div className="compact-cell">
                        <CustomTooltip content={item?.transactionId}>
                          <span
                            className="d-inline-block text-truncate"
                            style={{ maxWidth: "100%" }}
                          >
                            {item?.transactionId}
                          </span>
                        </CustomTooltip>
                      </div>
                    )}
                  </td>
                  {entityTypeId !== EntityType.Tenant && hasWritePermission && (
                    <td className="normal_text">
                      {hasWritePermission && (
                        editRowIndex === txIndex ? (
                          <div className="editViewBtn">
                            <AddTraspButton
                              imageValue={GetImages.bluetick}
                              IconClassName="iconstyle14"
                              iconPosition="right"
                              onClick={() => {
                                handleEdit();
                                handleSaveRow(txIndex);
                                setIsEdit(false);
                              }}
                            />
                            <AddTraspButton
                              imageValue={GetImages.greycross}
                              IconClassName="iconstyle12"
                              iconPosition="right"
                              onClick={() => {
                                handleSaveRow(txIndex);
                                setIsEdit(false);
                              }}
                            />
                          </div>
                        ) : (
                          <AddTraspButton
                            imageValue={GetImages.BluePencilEdit}
                            className="color-white-icon"
                            iconPosition="right"
                            onClick={() => {
                              handleEditRow(txIndex);
                              setIsEdit(true);
                            }}
                          />
                        )
                      )}
                    </td>
                  )}
                </tr>
              ))
            )}

            {/* Show loading spinner while loading more */}
            {loading1 && rows.length > 0 && (
              <tr className="flat-view-loader">
                <td colSpan={entityTypeId !== EntityType.Tenant && hasWritePermission ? 10 : 9}>
                  <SimpleSpinner myClassName="Icon40" />
                </td>
              </tr>
            )}

            {/* <-- 5. Move the sentryRef INSIDE the tbody, as the last element --> */}
            {hasMore && (
              <tr ref={sentryRef}>
                <td
                  colSpan={entityTypeId !== EntityType.Tenant && hasWritePermission ? 10 : 9}
                  style={{ height: "1px", padding: 0, border: "none" }}
                ></td>
              </tr>
            )}
          </tbody>
        </table>

      </div>
        </>
      )}

      {/* <-- 6. Remove the old sentryRef from here --> */}
      {/* {hasMore && <div ref={sentryRef} style={{ height: '20px' }} />} */}

      {!loading && rows.length > 0 && entityTypeId !== EntityType.Tenant && (
        <div className="transaction-summary-footer">
          <div className="summary-left">
            <span className="normal_text black fw-500 lblSummary">Summary</span>
          </div>
          <div
            className="summary-right d-flex gap-2 justify-content-end"
          >
            <span className="normal_text grey_subtext1 transaction-income">
              Income:
              <span className="black normal_text fw-600">
                <CurrencyTooltip
                  content={formattedAggregateValues?.TotalRevenueRaw}
                  formatted={formattedAggregateValues?.TotalRevenueFormatted}
                >
                  <span>
                    {formattedAggregateValues?.TotalRevenueFormatted || "NA"}
                  </span>
                </CurrencyTooltip>
              </span>
            </span>

            <SeparaterLine height={"26px"} background={"#e5e7eb"} />

            <span className="normal_text grey_subtext1 transaction-income">
              Expenses:
              <span className="black normal_text fw-600">
                <CurrencyTooltip
                  content={formattedAggregateValues?.TotalExpenseRaw}
                  formatted={formattedAggregateValues?.TotalExpenseFormatted}
                >
                  <span>
                    {formattedAggregateValues?.TotalExpenseFormatted || "NA"}
                  </span>
                </CurrencyTooltip>
              </span>
            </span>

            <SeparaterLine height={"26px"} background={"#e5e7eb"} />

            <span className="normal_text grey_subtext1 transaction-income">
              Net Income:
              <span className="black normal_text fw-600">
                <CurrencyTooltip
                  content={calculateValue?.NetProfitRaw}
                  formatted={calculateValue?.NetProfitFormatted}
                >
                  <span>{calculateValue?.NetProfitFormatted || "NA"}</span>
                </CurrencyTooltip>
              </span>
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default FlatViewTable;
